import { ReactElement, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { PageLoader } from '../common/components';

import LayoutWrapper from './LayoutWrapper';
import { defaultRoutes } from './routes';
import Constant from './Constant';

interface BaseRoute {
  path: string;
  element: ReactElement;
  layout?: string;
  children?: BaseRoute[];
}

interface AuthRoute extends BaseRoute {
  path: string;
  layout?: undefined;
}

export type AppRoute = BaseRoute | AuthRoute;

const transformRoutes = (routes: AppRoute[]): RouteObject[] => {
  return routes.map((route) => {
    const { path, element, layout, children } = route;
    return {
      path,
      element: layout ? (
        <LayoutWrapper layout={layout}>
          <Suspense
            fallback={
              <div>
                <PageLoader />
              </div>
            }
          >
            {element}
          </Suspense>
        </LayoutWrapper>
      ) : (
        <Suspense
          fallback={
            <div>
              <PageLoader />
            </div>
          }
        >
          {element}
        </Suspense>
      ),
      children: children ? transformRoutes(children) : undefined,
    };
  });
};

export const appRoutes = transformRoutes(defaultRoutes);
